import React from 'react';
import { Typography } from '@material-ui/core';

/**
 * The owner-only figures on a post card — watch time, watch %, shares.
 * Only connected creators' posts carry `insights` (the API omits the key
 * for scraped channels), so for everyone else this renders nothing.
 */
function formatDuration(seconds) {
  const total = Math.round(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return m ? `${m}m ${s}s` : `${s}s`;
}

export default function PostInsights({ insights }) {
  if (!insights || !Object.keys(insights).length) return null;
  const parts = [];
  if (insights.avg_view_duration_s) {
    parts.push(`${formatDuration(insights.avg_view_duration_s)} avg watch`);
  }
  if (insights.avg_view_pct) {
    parts.push(`${Math.round(insights.avg_view_pct)}% watched`);
  }
  if (insights.shares) {
    parts.push(`${insights.shares} shares`);
  }
  if (!parts.length) return null;
  return (
    <Typography
      variant="body2"
      title="Measured from the creator's own account, not estimated"
      style={{
        marginTop: 8,
        fontSize: 12,
        fontWeight: 600,
        color: '#0A6B5C',
        background: '#E7F6F0',
        border: '1px solid #BFE5D9',
        borderRadius: 6,
        padding: '3px 8px',
      }}
    >
      {parts.join(' · ')}
    </Typography>
  );
}
